import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FollowUp, OnSubmitFollowUp, TreatmentRequestExtended} from '@/features/treatment-requests/types'
import {TreatmentRequestFollowUpForm} from '@/features/treatment-requests/components/treatment-request-follow-up-form/TreatmentRequestFollowUpForm'
import {useUpdateFollowUp} from '@/features/treatment-requests/services/useUpdateFollowUp'
import {useTranslation} from '@/translations/i18n'
import {QUERY_KEYS, queryClient} from '@/queryClient'
import {errorHandler} from '@/utilities/helpers'
import {formatDate} from '@/dayjs'
import {useOutletContext} from 'react-router-dom'
import {Text} from '@/components/ui/text/Text'

export const TreatmentRequestEditFollowUp = ({
    followUpToEdit,
    isLastFollowUp,
    onCancel
}: {
    followUpToEdit: FollowUp
    isLastFollowUp: boolean
    onCancel: () => void
}) => {
    const {t} = useTranslation()
    const {
        treatmentRequest: {id}
    } = useOutletContext<{treatmentRequest: TreatmentRequestExtended}>()

    const updateFollowUpMutation = useUpdateFollowUp({
        urlParams: {followUpId: followUpToEdit.id},
        options: {
            onSuccess: () => {
                onCancel()
                void queryClient.cancelQueries({queryKey: [QUERY_KEYS.TREATMENT_REQUESTS, id]})
                void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.TREATMENT_REQUESTS, id]})
            },
            onError: errorHandler
        }
    })

    const handleUpdateFollowUp = ({date, notes}: OnSubmitFollowUp<FollowUp>) => {
        updateFollowUpMutation.mutate({
            date: isLastFollowUp && date ? formatDate(date.toISOString(), 'YYYY-MM-DD') : undefined,
            notes
        })
    }

    return (
        <Flexbox direction="column" gap={3} fullWidth>
            <Text size="textSm">{t('treatment_requests:edit_follow_up')}</Text>
            <TreatmentRequestFollowUpForm
                defaultValues={followUpToEdit}
                onSubmit={handleUpdateFollowUp}
                disabledDate={!isLastFollowUp}
                isLoading={updateFollowUpMutation.isPending}
                onCancel={onCancel}
            />
        </Flexbox>
    )
}
